import { TFunction } from 'i18next'

type DashPlaceholder = (text?: string | number | null) => string | number
type NAPlaceholder = (t: TFunction, text?: string | number | null) => string | number

export const placeholder: {
  dash: DashPlaceholder
  NA: NAPlaceholder
} = {
  dash: (text) => text ?? '—',
  NA: (t, text) => text ?? t('N/A'),
}
